import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import appsData from '../../apps-data';
import {className} from 'henrybuilt-react-library';
import './header.scss';

class Header extends React.Component {
  render() {
    var {appKey, session, ...props} = this.props;

    var {accountsDomain} = this;
    var appData = appsData[appKey];
    
    return (
      <div className='hb-header'>
        {appData !== undefined && (<div className='app-name'>
          <a href={appData.domain} style={{...appData.style}}>{appData.title}</a>
        </div>)}
        <div className='menu-button'>

        </div>
        <div className='inline-links'>

        </div>

        {session.isLoggedIn && (
          <>
            <div className='session-links'>
              <a {...className([props.location.pathname === '/logout' && 'active'])} href={`${accountsDomain}/logout`}>Log out</a>
            </div>
          </>
        )}
      </div>
    );
  }

  get accountsDomain() {
    return process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://henrybuilt.com';
  }
}

export default connect(state => _.pick(state, ['session']))(Header);
